<div class="c-success">
  <img class="c-success__img" src="/assets/images/simbolos/verificar.svg" alt="Sucesso">
  <p class="is-title">Chamado "{{queryParams.codigoOs}}" foi registrado com sucesso!</p>
  <p class="c-success__text">Para visualizar os detalhes do Chamado,
    <a class="is-link" [routerLink]="['/historico-de-chamados', queryParams.numSerie, queryParams.codContrato]"
      [queryParams]="{codigoOs: queryParams.codigoOs}">clique
      aqui!</a>
  </p>
</div>
